import { put, call } from 'redux-saga/effects';
import { DashboardAction,UIAction } from '../actions';
import { DashboardService } from '../services';
import { generateReadableError } from 'hooks';



export function* getDashboardAnalytics(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchAnalytics, action.payload);
    yield put(DashboardAction.getAnalyticsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getGoogleAnalytics(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showGoogleLoading(true));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchGoogleAnalytics, action.payload);
    yield put(DashboardAction.getGoogleAnalyticsSuccess(data));
    yield put(UIAction.showGoogleLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showGoogleLoading(false));
  }
}

export function* getGoogleAnalyticsGraph(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showGoogleGraphLoading(true));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchGoogleAnalyticsGraph, action.payload);
    yield put(DashboardAction.getGoogleAnalyticsGraphSuccess(data));
    yield put(UIAction.showGoogleGraphLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showGoogleGraphLoading(false));
  }
}

export function* getTopSearches(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showTopSearchesLoading(true));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchTopSearches, action.payload);
    yield put(DashboardAction.getTopSearchesSuccess(data));
    yield put(UIAction.showTopSearchesLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showTopSearchesLoading(false));
  }
}

export function* getCampaignAnalytics(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(DashboardAction.getCampaignAnalyticsSuccess(null));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchCampaignAnalytics, action.payload);
    yield put(DashboardAction.getCampaignAnalyticsSuccess(data.data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }

}

export function* getTransactionsGraphData(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(DashboardAction.getTransactionsGraphDataSuccess(null));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchTransactionsGraphData, action.payload);
    yield put(DashboardAction.getTransactionsGraphDataSuccess(data.data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }

}

export function* getActiveCampaignMapData(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  yield put(DashboardAction.getActiveCampaignMapDataSuccess(null));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchActivecampaignMapData, action.payload);
    yield put(DashboardAction.getActiveCampaignMapDataSuccess(data.data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }

}



export function* getFailedUrlsData(action) {

  yield put(UIAction.showMessages(null));
  yield put(UIAction.showFailedUrlLoading(true));
  yield put(DashboardAction.getFailedUrlsDataSuccess(null));
  try {
    const {data}  = yield call(DashboardService.getInstance().fetchFailedUrlData, action.payload);
    yield put(DashboardAction.getFailedUrlsDataSuccess(data.data));
    yield put(UIAction.showFailedUrlLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
  }

}


export function* saveDashboardWidget(action) {
  //yield put(UIAction.showMainLoading(true));
  yield put(UIAction.showMessages(null));
  yield put(DashboardAction.saveDashboardWidgetSuccess(null));
  try {

    const {data}  = yield call(DashboardService.getInstance().saveDashboardWidget, action.payload);
    yield put(DashboardAction.saveDashboardWidgetSuccess(data.data));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    console.log(e)
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }

}

export function* getDashboardWidget(action) {
  //yield put(UIAction.showMainLoading(true));
  yield put(UIAction.showMessages(null));
  yield put(DashboardAction.saveDashboardWidgetSuccess(null));
  try {
    const {data}  = yield call(DashboardService.getInstance().getDashboardWidget, action.payload);
    
    yield put(DashboardAction.saveDashboardWidgetSuccess(data.data));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }

}





